/**
 * What happens to a player's character while the player is away, in words.
 *
 * The same three answers appear in two places — the table-wide default in Settings and a seat's own
 * override in the roster on the Table tab — and used to be worded twice, one of them as the stored
 * keys ("benched", "autoPass"). One table, so a choice reads the same wherever it is made.
 *
 * Display only: what is sent to the server is the key.
 */

export const AWAY_POLICIES = ['benched', 'autoPass'] as const;
export type AwayPolicy = (typeof AWAY_POLICIES)[number];

export const AWAY_POLICY_LABELS: Readonly<Record<AwayPolicy, string>> = {
  benched: 'Benched — their character sits the scene out',
  autoPass: 'Auto-pass — their turn passes',
};

/** The empty choice on a seat: not an override, but "do what the table setting says". */
export const USE_TABLE_SETTING = 'Use the table setting';

/**
 * Said once, shown wherever the choice is made.
 *
 * It applies only while the player is away; a player who is present is always waited for.
 */
export const AWAY_POLICY_HELP =
  'This only applies while that player is actually away — a player who is here is always waited for. ' +
  'Benched: their character is left out of any fight that starts while they are away. ' +
  'Auto-pass: their character stays in the fight and its turns are passed for them.';
